import appBulkBonuses from "../../views/appSettings/bulkBonuses.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "bulk-bonuses";
  const params = ["page", "limit"];

  $stateProvider.state("bulkbonuses", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appBulkBonuses,
      },
    },
    reloadOnSearch: false,
    data: { title: "BulkBonuses" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/bulkBonuses/bulkBonuses.urls.js